import Vue from 'vue'
import VueRouter from 'vue-router'
import { MessageBox } from 'mint-ui'
import { isLogged, toLogin, getHostName, isNeedAuthPath } from './util/function'
import { getQueryUrl } from './util/getQueryUrl.js'
import theme from './theme'
import _ from 'underscore'
import cookie from './lib/cookie'
import constant from './constant/cookie'
import COMMONCONSTANT from './constant/common'
import sdtj from '@sdtj/util'
import sdtjRoutes from '@sdtj/router'
import homeCom from './view/home/home_main.vue'

const routes = [
  ...sdtjRoutes,
  {
    path: '/transferPage',
    title: 'transferPage',
    name: 'transferPage',
    component: () => import('./view/transferPage/main.vue'),
  },
  {
    path: '/activityT',
    title: 'activityT',
    name: 'activityT',
    component: () => import('./view/activityT/index.vue'),
  },
  {
    path: '/testview',
    title: 'testview',
    name: 'testview',
    component: () => import('./view/testview/main.vue'),
  },
  {
    path: '/testGisMaps',
    title: 'testGisMaps',
    name: 'testGisMaps',
    component: () => import('./view/gisMaps/index.vue'),
  },
  {
    path: '/',
    title: '商城首页',
    name: 'home',
    // component: r => require.ensure([], () => r(require('./view/home/home_main.vue')), 'home'),
    component: homeCom,
  },
  {
    path: '/home/:id',
    title: '首页品类',
    name: 'homeCategory',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/home/home_category.vue')),
        'homeCategory'
      ),
  },
  {
    path: '/notices',
    title: '平台公告',
    name: 'notices',
    meta: {
      title: '平台公告',
    },
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/notice/platform/platform.vue')),
        'notices'
      ),
  },
  {
    path: '/noticesDetails',
    title: '平台公告',
    name: 'noticesDetails',
    meta: {
      title: '平台公告',
    },
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/notice/noticesDetails/noticesDetails.vue')),
        'noticesDetails'
      ),
  },
  {
    path: '/items',
    title: '商品列表',
    name: 'itemList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/item/list/main.vue')),
        'items'
      ),
  },
  {
    path: '/global/:categoryId',
    title: '全球购',
    name: 'globalMain',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/global_shopping/global_main.vue')),
        'globalMain'
      ),
  },
  {
    path: '/global/:categoryId/:id',
    title: '全球购',
    name: 'globalCategory',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/global_shopping/global_category.vue')),
        'globalCategory'
      ),
  },
  {
    path: '/product/:id',
    title: '商品详情',
    name: 'itemDetail',
    component: (r) =>
      require.ensure([], () => r(require('./view/item/main.vue')), 'item'),
  },
  {
    path: '/product/:id/store',
    title: '门店列表',
    name: 'storeList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/store/list_main.vue')),
        'storeList'
      ),
  },
  {
    path: '/product/:id/store/:storeId',
    title: '门店信息',
    name: 'storeDetail',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/store/detail_main.vue')),
        'storeDetail'
      ),
  },
  {
    path: '/center',
    title: '个人中心',
    name: 'center',
    component: (r) =>
      require.ensure([], () => r(require('./view/center/main.vue')), 'center'),
  },
  {
    path: '/center/setting',
    title: '设置',
    name: 'setting',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/center/sub_view/setting.vue')),
        'setting'
      ),
  },
  {
    path: '/center/setting/closeAccount',
    title: '账号注销',
    name: 'closeAccount',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/center/account/close_account.vue')),
        'closeAccount'
      ),
  },
  {
    path: '/center/setting/chooseChannl',
    title: '账号注销',
    name: 'chooseChannl',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/center/account/choose_channl.vue')),
        'chooseChannl'
      ),
  },
  {
    path: '/center/setting/closeNeedKnow',
    title: '账号注销须知',
    name: 'closeNeedKnow',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/center/account/close_need_know.vue')),
        'closeNeedKnow'
      ),
  },
  {
    path: '/center/setting/accountSecurity',
    title: '账号安全',
    name: 'accountSecurity',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/center/account/account_security.vue')),
        'accountSecurity'
      ),
  },
  {
    path: '/center/setting/closeSuccess',
    title: '注销结果',
    name: 'closeSuccess',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/center/account/close_success.vue')),
        'closeSuccess'
      ),
  },
  {
    path: '/user',
    title: '我的资料',
    name: 'user',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/center/sub_view/me_detail.vue')),
        'user'
      ),
  },
  {
    path: '/user/order',
    title: '订单列表',
    name: 'userOrder',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/order/list.vue')),
        'userOrder'
      ),
  },
  {
    path: '/user/order/twoyear',
    title: '订单列表',
    name: 'userOrderTwoYear',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/order/twoYearList.vue')),
        'userOrderTwoYear'
      ),
  },
  {
    path: '/user/group-order',
    title: '拼团订单',
    name: 'userGroupOrder',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/order/group_list.vue')),
        'userGroupOrder'
      ),
  },
  {
    path: '/user/order/:id',
    title: '订单详情',
    name: 'userOrderDetail',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/order/detail.vue')),
        'userOrderDetail'
      ),
  },
  {
    path: '/user/order/:id/old',
    title: '订单详情',
    name: 'userOrderDetailOld',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/order/detail_old.vue')),
        'userOrderDetailOld'
      ),
  },
  {
    path: '/preorder/pay/callback/:id',
    title: '支付结果',
    name: 'preorderPayCallback',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/preorder/pay/callback.vue')),
        'preorderPayCallback'
      ),
  },
  {
    path: '/preorder/:id/pay/wechat/:payType',
    title: '微信支付',
    name: 'preorderPayWechat',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/preorder/pay/wechat.vue')),
        'preorderPayWechat'
      ),
  },
  {
    path: '/preorder/:key/goods',
    title: '商品清单',
    name: 'preorderGoodsList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/preorder/goods_list.vue')),
        'preorderGoodsList'
      ),
  },
  {
    path: '/preorder/:key/bundleSale',
    title: '搭售商品',
    name: 'bundleSaleGoods',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/preorder/bundle_sale_goods.vue')),
        'bundleSaleGoods'
      ),
  },
  {
    path: '/preorder/:key/store',
    title: '门店信息',
    name: 'preorderStoreList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/store/preorder_store_list.vue')),
        'preorderStoreList'
      ),
  },
  {
    path: '/address',
    title: '地址管理',
    name: 'addressList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/address/list.vue')),
        'address'
      ),
  },
  {
    path: '/user/address',
    title: '收货地址列表',
    name: 'userAddress',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/address/list.vue')),
        'userAddress'
      ),
  },
  {
    path: '/user/address/:id/edit',
    title: '修改收货地址',
    name: 'userAddressUpdate',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/address/addOrEdit.vue')),
        'userAddressUpdate'
      ),
  },
  {
    path: '/user/address/add',
    title: '新增收货地址',
    name: 'userAddressAdd',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/address/addOrEdit.vue')),
        'userAddressAdd'
      ),
  },
  {
    path: '/user/address/select',
    title: '地址管理',
    name: 'userAddressSelect',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/address/list.vue')),
        'userAddress'
      ),
  },
  {
    path: '/user/address/poipicker',
    title: '新建地址',
    name: 'addressPoipicker',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/poipicker/main_v2.vue')),
        'addressPoiPicker'
      ),
  },
  {
    path: '/user/exchange',
    title: '历史记录',
    name: 'exchangeList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/exchange/list.vue')),
        'exchangeList'
      ),
  },
  {
    path: '/user/exchange/detail',
    title: '历史记录详情',
    name: 'exchangeDetail',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/exchange/detail.vue')),
        'exchangeDetail'
      ),
  },
  {
    path: '/user/card',
    title: '券包',
    name: 'userCard',
    component: (r) =>
      require.ensure([], () => r(require('./view/card/index.vue')), 'userCard'),
  },
  {
    path: '/preorder/card',
    title: '券包', // 确认订单页券包
    name: 'preorderCards',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/preorderCards.vue')),
        'preorderCards'
      ),
  },
  {
    path: '/user/card/query',
    title: `${theme.get('CARD_NAME')}查询`,
    name: 'userCardQuery',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/query.vue')),
        'userCardQuery'
      ),
  },
  {
    path: '/preorder/card/query',
    title: `${theme.get('CARD_NAME')}查询`,
    name: 'preorderCardQuery',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/query.vue')),
        'preorderCardQuery'
      ),
  },
  {
    path: '/user/card/detail/:id',
    title: `${theme.get('CARD_NAME')}详情`,
    name: 'userCardDetail',
    meta: {
      title: '券详情',
    },
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/detail.vue')),
        'userCardDetail'
      ),
  },
  {
    path: '/user/card/delayRecord/:id',
    title: `延期记录`,
    name: 'delayRecord',
    meta: {
      title: '延期记录',
    },
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/delayRecord/delayRecord.vue')),
        'delayRecord'
      ),
  },
  {
    path: '/user/card/delayRecordDetails/:id',
    title: `延期详情`,
    name: 'delayRecordDetails',
    meta: {
      title: '延期详情',
    },
    component: (r) =>
      require.ensure(
        [],
        () =>
          r(require('./view/card/delayRecordDetails/delayRecordDetails.vue')),
        'delayRecordDetails'
      ),
  },
  {
    path: '/preorder/card/detail/:id',
    title: `${theme.get('CARD_NAME')}详情`,
    name: 'preorderCardDetail',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/detail.vue')),
        'preorderCardDetail'
      ),
  },
  {
    path: '/card/detail/goStore',
    title: '进店使用',
    name: 'goStoreCard',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/goStore.vue')),
        'goStoreCard'
      ),
  },
  {
    path: '/card/detail/paymentCode',
    title: '核销二维码',
    name: 'paymentCode',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/paymentCode.vue')),
        'paymentCode'
      ),
  },
  {
    path: '/card/detail/paymentCodeSuc',
    title: '核销二维码成功',
    name: 'paymentCodeSuc',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/paymentCodeSuc.vue')),
        'paymentCodeSuc'
      ),
  },
  {
    path: '/card/detail/:id/rule',
    title: '使用规则',
    name: 'filmCardRule',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/film_card_rule.vue')),
        'preorderFilmCardDetail'
      ),
  },
  {
    path: '/app-card/detail/rule',
    title: '使用规则',
    name: 'filmAppCardRule',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/film_card_rule.vue')),
        'preorderFilmCardDetail'
      ),
  },
  {
    path: '/card/detail/category-rule',
    title: '使用规则',
    name: 'categoryCardRule',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/category_card_rule.vue')),
        'categoryCardRule'
      ),
  },
  {
    path: '/card/detail/gift-rule',
    title: '使用规则',
    name: 'giftCardRule',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/gift_card_rule.vue')),
        'giftCardRule'
      ),
  },
  {
    path: '/card/detail/useIntegralRule',
    title: '积分使用规则',
    name: 'useIntegralRule',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/useIntegralRule.vue')),
        'useIntegralRule'
      ),
  },
  {
    path: '/card/detail/limit/cinema',
    title: '线下可兑换影院',
    name: 'limitCinema',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/limit_cinema.vue')),
        'limitCinemaDetail'
      ),
  },
  {
    path: '/card/detail/search/cinema',
    title: '搜索可兑换影院',
    name: 'serchCinema',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/search_cinema.vue')),
        'searchLimitCinema'
      ),
  },
  {
    path: '/card/detail/limit/city',
    title: '选择城市',
    name: 'limitCity',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/limit_city.vue')),
        'limitCityDetail'
      ),
  },
  {
    path: '/card/detail/limit/cinema/detail/:id',
    title: '选择城市',
    name: 'cinemaDetail',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/limit_cinemaDetail.vue')),
        'cinemaDetail'
      ),
  },
  {
    path: '/card/detail/consume',
    title: '兑换明细',
    name: 'cardConsume',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/card_consume.vue')),
        'cardConsume'
      ),
  },
  {
    path: '/card/detail/consume/detail',
    title: '兑换详情',
    name: 'cardConsumeDetail',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/card_consume_detail.vue')),
        'cardConsumeDetail'
      ),
  },
  {
    path: '/card/query/:qrcode', // 商城内 二维码查券结果
    title: `${theme.get('CARD_NAME')}查询`,
    name: 'qrCodeCardQuery',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/query.vue')),
        'qrCodeCardQuery'
      ),
  },
  {
    path: '/card/query', // 微信扫一扫 二维码查券结果
    title: `${theme.get('CARD_NAME')}查询`,
    name: 'qrCodeCardQuery2',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/query.vue')),
        'qrCodeCardQuery2'
      ),
  },
  {
    path: '/preorder/card/bindSuccess', // 从商品订单过来的 绑券成功页面
    title: '绑定成功',
    name: 'preorderBindSuccess',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/bindSuccess.vue')),
        'preorderBindSuccess'
      ),
  },
  {
    path: '/user/card/bindSuccess', // 从个人中心过来的 绑券成功页面
    title: '绑定成功',
    name: 'userBindSuccess',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/bindSuccess.vue')),
        'userBindSuccess'
      ),
  },
  {
    path: '/preorder/:key',
    title: '确认订单',
    name: 'preorder',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/preorder/index.vue')),
        'preorder'
      ),
  },
  {
    path: '/cardDelay/:key',
    title: '确认订单',
    name: 'cardRreorder',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/cardDelay/index.vue')),
        'cardDelay'
      ),
  },
  {
    path: '/card/password',
    title: '券号密码',
    name: 'cardPassword',
    meta: {
      title: '券号密码',
    },
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/viewCardPass/viewCardPass')),
        'cardPassword'
      ),
  },
  {
    path: '/card/detail/delayHelp',
    title: '券延期说明',
    name: 'cardDelayHelp',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/card/delay_help')),
        'cardDelayHelp'
      ),
  },
  // {
  //   path: '/preorder/:id/cash',
  //   title: '现金支付',
  //   name: 'cash',
  //   component: r => require.ensure([], () => r(require('./view/preorder/cash.vue')), 'cash'),
  // },
  {
    path: '/recharge',
    title: '充值',
    name: 'recharge',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/recharge/main.vue')),
        'recharge'
      ),
    children: [
      {
        path: 'cost',
        title: '充值',
        name: 'rechargeCost',
        component: (r) =>
          require.ensure(
            [],
            () => r(require('./view/recharge/cost.vue')),
            'rechargeCost'
          ),
      },
      {
        path: 'flow',
        title: '充值',
        name: 'rechargeFlow',
        component: (r) =>
          require.ensure(
            [],
            () => r(require('./view/recharge/flow.vue')),
            'rechargeFlow'
          ),
      },
      {
        path: 'fuel',
        title: '充值',
        name: 'rechargeFuel',
        component: (r) =>
          require.ensure(
            [],
            () => r(require('./view/recharge/fuel.vue')),
            'rechargeFuel'
          ),
      },
    ],
  },
  {
    path: '/rechargeHelp',
    title: '充值说明',
    name: 'rechargeHelp',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/recharge/help.vue')),
        'rechargeHelp'
      ),
  },
  {
    path: '/cart',
    title: '购物车',
    name: 'cart',
    component: (r) =>
      require.ensure([], () => r(require('./view/cart/main.vue')), 'cart'),
  },
  {
    path: '/cart/add_products',
    title: '凑单商品',
    name: 'addProducts',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/cart/add_products.vue')),
        'addProducts'
      ),
  },
  {
    path: '/category/:id',
    title: '一级品类',
    name: 'category',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/category/main.vue')),
        'category'
      ),
  },
  {
    path: '/category/:id/filter',
    title: '',
    name: 'categoryFilter',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/category/filter/main.vue')),
        'categoryFilter'
      ),
  },
  {
    path: '/category/welfare/:categoryId',
    title: '档位券',
    name: 'categoryWelfare',
    component: () => import('./view/category/welfare/main.vue'),
  },
  {
    path: '/category/welfare/simple/:categoryId',
    title: '档位券',
    name: 'categoryWelfareSimple',
    component: () => import('./view/category/welfare/main.vue'),
  },
  {
    path: '/search',
    title: '搜索页面',
    name: 'search',
    component: (r) =>
      require.ensure([], () => r(require('./view/search/main.vue')), 'search'),
  },
  {
    path: '/search/result2',
    title: '搜索结果页',
    name: 'searchResultV2',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/search/result/main_v2.vue')),
        'search-result2'
      ),
  },
  {
    path: '/search/result',
    title: '搜索结果页',
    name: 'searchResult',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/search/result/main.vue')),
        'search-result'
      ),
  },
  {
    path: '/topic/:id',
    title: '专题商品列表',
    name: 'topic',
    component: (r) =>
      require.ensure([], () => r(require('./view/topic/main.vue')), 'topic'),
  },
  {
    path: '/enterprise/',
    title: '企业福利',
    name: 'enterprise',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/enterprise/main.vue')),
        'enterprise'
      ),
    // beforeEnter: (to, from, next) => {
    //   const redirectUrl = getHostName() + '/v1/#/enterprise'
    //   if (!isLogged()) {
    //     return toLogin(redirectUrl)
    //   }
    //   next()
    // }
  },
  {
    path: '/enterprise/check',
    title: '企业福利',
    name: 'enterpriseCheck',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/enterprise/check.vue')),
        'enterpris-check'
      ),
    beforeEnter: (to, from, next) => {
      const redirectUrl = `${getHostName()}/v1/#/enterprise/check`
      if (!isLogged()) {
        return toLogin(redirectUrl)
      }
      next()
    },
  },
  {
    path: '/appShare',
    title: '苏打爱生活',
    name: 'appShare',
    component: (r) =>
      require.ensure([], () => r(require('./view/share/app.vue')), 'app-share'),
  },
  {
    path: '/commonShare',
    title: '苏打爱生活',
    name: 'commonShare',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/share/common.vue')),
        'common-share'
      ),
  },
  {
    path: '/user/coupon',
    title: '我的现金券',
    name: 'userCoupon',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/coupon/main.vue')),
        'user-coupon'
      ),
  },
  {
    path: '/preorder/:key/coupon',
    title: '我的现金券',
    name: 'preorderCoupon',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/coupon/list_in_preorder.vue')),
        'preorder-coupon'
      ),
  },

  {
    path: '/user/order/:orderId/logistics', // h5
    title: '物流信息',
    name: 'logistics',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/order/logistics/main.vue')),
        'logistics'
      ),
  },
  {
    path: '/app-user/logistics/:orderId', // app
    title: '物流信息',
    redirect: {
      name: 'logistics',
    },
  },
  {
    path: '/user/you-should-know',
    title: '苏打爱生活服务协议',
    name: 'you-should-know',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/global/you_should_know.vue')),
        'you-should-know'
      ),
  },
  {
    path: '/user/refund-exchange-policy',
    title: '退换货须知',
    name: 'refund-exchange-policy',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/global/refund_exchange_policy.vue')),
        'refund-exchange-policy'
      ),
  },
  {
    path: '/user/order/:orderId/refundApply',
    title: '申请退款',
    name: 'refundApply',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/refund/apply.vue')),
        'refundApply'
      ),
  },
  {
    path: '/user/order/:orderId/refundDetail',
    title: '退款详情',
    name: 'refundDetail',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/refund/detail.vue')),
        'refundDetail'
      ),
  },
  {
    path: '/user/refund',
    title: '售后退款',
    name: 'refundList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/refund/list.vue')),
        'refundList'
      ),
  },
  {
    path: '/user/balance',
    title: '我的积分',
    name: 'userBalance',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/balance/index.vue')),
        'userBalance'
      ),
  },
  {
    path: '/user/balance/timeLimit',
    title: '积分有效期',
    name: 'balanceTimeLimit',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/balance/time_limit.vue')),
        'balanceTimeLimit'
      ),
  },
  {
    path: '/user/balance/:recordId',
    title: '明细详情',
    name: 'balanceRecordDetail',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/balance/record_detail.vue')),
        'balanceRecordDetail'
      ),
  },
  {
    path: '/recommend',
    title: '人气优选',
    name: 'recommend',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/recommend/main.vue')),
        'recommend'
      ),
  },
  {
    path: '/buyer',
    title: '买手秀',
    name: 'buyerShow',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/buyer/main.vue')),
        'buyerShow'
      ),
  },
  {
    path: '/welfare',
    title: '企业福利',
    name: 'welfare',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/welfare/main.vue')),
        'welfare'
      ),
  },
  {
    path: '/group',
    title: 'UU团',
    name: 'group',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/group/home/main.vue')),
        'group'
      ),
  },
  {
    path: '/group/join/:productId',
    title: '参与拼单',
    name: 'join',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/group/join/main.vue')),
        'join'
      ),
  },
  {
    path: '/group/:productId',
    title: '拼团详情',
    name: 'detail',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/group/detail/main.vue')),
        'detail'
      ),
  },
  {
    path: '/id_card',
    title: '我的身份证',
    name: 'myIdCard',
    component: (r) =>
      require.ensure([], () => r(require('./view/id_card/main.vue')), 'idCard'),
  },
  {
    path: '/id_card/upload',
    title: '我的身份证',
    name: 'myIdCardUpload',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/id_card/upload_detail.vue')),
        'idCardUpload'
      ),
  },
  {
    // 分期付款
    path: '/installment/bankList/:payOrderId',
    title: '银行列表',
    name: 'installment_bankList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/installment/bank_list.vue')),
        'installment-banks'
      ),
  },
  {
    // 分期付款
    path: '/installment/detail/:payOrderId/:bankId',
    title: '付款详情',
    name: 'installment',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/installment/main.vue')),
        'installment'
      ),
  },
  {
    // 银行卡开通支付
    path: '/installment/open/:bankCard',
    title: '支付开通',
    name: 'installment_openpay',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/installment/open_pay.vue')),
        'installment-openpay'
      ),
  },
  {
    // 开通结果回调
    path: '/installment/open/result/:bankCard',
    title: '开通支付',
    name: 'installment_open_result',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/installment/open_result.vue')),
        'installment-open-result'
      ),
  },
  {
    path: '/service/center',
    title: '帮助中心',
    name: 'serviceCenter',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/service/main.vue')),
        'serviceCenter'
      ),
  },
  {
    path: '/service/info/:id',
    title: '帮助中心',
    name: 'serviceInfo',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/service/info.vue')),
        'serviceInfo'
      ),
  },
  {
    path: '/fenqile/login',
    title: '分期乐登陆',
    name: 'fenqileLogin',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/fenqile/login.vue')),
        'fenqile-login'
      ),
  },
  {
    path: '/fenqile/amount',
    title: '分期乐额度',
    name: 'fenqileAmount',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/fenqile/amount.vue')),
        'fenqile-amount'
      ),
  },
  {
    path: '/fenqile/pay',
    title: '分期乐支付',
    name: 'fenqilePay',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/fenqile/pay.vue')),
        'fenqile-pay'
      ),
  },
  {
    path: '/user/order/:orderId/invoice/info',
    title: '发票信息',
    name: 'invoiceInfo',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/order/invoice/info.vue')),
        'invoiceInfo'
      ),
  },
  {
    path: '/user/order/:orderId/invoice/detail',
    title: '发票详情',
    name: 'invoiceDetail',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/order/invoice/detail.vue')),
        'invoiceDetail'
      ),
  },
  {
    path: '/city',
    title: '选择城市',
    name: 'cityList',
    component: (r) =>
      require.ensure([], () => r(require('./view/city/list.vue')), 'cityList'),
  },
  {
    path: '/lucky-money/join/:luckyMoneyActiveCode',
    title: '福利社红包',
    name: 'luckyMoneyJoin',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/lucky_money/join.vue')),
        'welfareJoin'
      ),
  },
  {
    path: '/lucky-money/detail/:luckyMoneyId',
    title: '红包详情',
    name: 'luckyMoneyDetail',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/lucky_money/detail.vue')),
        'luckyMoneyDetail'
      ),
  },
  {
    path: '/common/toapp',
    title: '前往APP',
    name: 'toApp',
    component: (r) =>
      require.ensure([], () => r(require('./view/global/toApp.vue')), 'toApp'),
  },
  {
    path: '/colleaguesBuyShare/:groupCode',
    title: '同事购拼团分享',
    name: 'colleaguesBuyShare',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/colleaguesBuyShare/main.vue')),
        'colleaguesBuyShare'
      ),
  },
  {
    path: '/colleaguesBuyShare/rule',
    title: '同事团玩法',
    name: 'colleaguesBuyShareRule',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/colleaguesBuyShare/rule.vue')),
        'colleaguesBuyShareRule'
      ),
  },
  {
    path: '/zone/:id',
    title: '专区',
    name: 'zone',
    component: (r) =>
      require.ensure([], () => r(require('./view/zone/main.vue')), 'zone'),
  },
  {
    path: '/zone/filter/:id',
    title: '专区筛选页',
    name: 'zoneFilter',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/zone/filter.vue')),
        'zoneFilter'
      ),
  },
  {
    path: '/poipicker',
    title: '选择地址',
    name: 'poipicker',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/poipicker/main.vue')),
        'poipicker'
      ),
  },
  {
    path: '/applicable',
    title: '蛋糕plus适用门店',
    name: 'applicableList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/applicable/list.vue')),
        'applicableList'
      ),
  },
  {
    path: '/applicable/city',
    title: '蛋糕plus适用门店城市选择',
    name: 'applicableCityList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/applicable/city.vue')),
        'applicableCityList'
      ),
  },
  {
    path: '/user/examine',
    title: '我的体检',
    name: 'userExamine',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/order/list.vue')),
        'userExamine'
      ),
  },
  {
    path: '/examine/item/:id',
    title: '体检详情',
    name: 'examineItem',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/item/main.vue')),
        'examineItem'
      ),
  },
  {
    path: '/user/examine/:orderId/sku/:skuId',
    title: '体检预约',
    name: 'examineCreate',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/reserve/create_reserve.vue')),
        'examineCreate'
      ),
  },
  {
    path: '/user/examine/info/:examineOrderId',
    title: '预约详情',
    name: 'examineEdit',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/reserve/edit_reserve.vue')),
        'examineEdit'
      ),
  },
  {
    path: '/examine/examiner/add',
    title: '体检人',
    name: 'examinerAdd',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/examiner/edit.vue')),
        'examinerEdit'
      ),
  },
  {
    path: '/examine/examiner/:examinerId',
    title: '体检人',
    name: 'examinerEdit',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/examiner/edit.vue')),
        'examinerEdit'
      ),
  },
  {
    path: '/examine/examiner',
    title: '选择体检人',
    name: 'examinerList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/examiner/list.vue')),
        'examinerEdit'
      ),
  },
  {
    path: '/user/examine/result/:url',
    title: '报告查询',
    name: 'examineResult',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/order/result.vue')),
        'examineResult'
      ),
  },
  {
    path: '/examine/agencylist/:skuId',
    title: '机构列表',
    name: 'agencyList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/agency/list.vue')),
        'agencyList'
      ),
  },
  {
    path: '/preorder/:preorderId/agencylist',
    title: '机构列表',
    name: 'preorderAgencyList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/agency/list.vue')),
        'agencyList'
      ),
  },
  {
    path: '/examine/agency/:agencyId',
    title: '机构详情',
    name: 'agencyDetail',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/agency/detail.vue')),
        'agencyDetail'
      ),
  },
  {
    path: '/examine/agency/:agencyId/info',
    title: '机构信息',
    name: 'agencyInfo',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/agency/agency_info.vue')),
        'agencyInfo'
      ),
  },
  {
    path: '/examine',
    title: '健康生活',
    name: 'examine',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/home/main.vue')),
        'examine'
      ),
  },
  {
    path: '/examine/filter/agency',
    title: '找机构',
    name: 'filterAgency',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/agency/filter_list.vue')),
        'filterAgency'
      ),
  },
  {
    path: '/examine/filter/package',
    title: '找套餐',
    name: 'filterPackage',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/examine/package/filter_list.vue')),
        'filterPackage'
      ),
  },
  {
    path: '/user/gift/order',
    title: '我的礼品库',
    name: 'giftOrderList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/gift/order/list.vue')),
        'giftOrderList'
      ),
  },
  {
    path: '/gift',
    title: '礼品首页',
    name: 'giftIndex',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/gift/main/index.vue')),
        'giftIndex'
      ),
  },
  {
    path: '/gift/receive/:giftToken',
    title: '领取页面',
    name: 'giftReceive',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/gift/receive/index.vue')),
        'giftReceive'
      ),
  },
  {
    path: '/gift/receive/:giftToken/submit',
    title: '领取礼物',
    name: 'receiveInput',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/gift/receive/submit.vue')),
        'giftReceiveSubmit'
      ),
  },
  {
    path: '/gift/receive/:giftToken/result',
    title: '领取结果',
    name: 'receiveResult',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/gift/receive/receive_result.vue')),
        'receiveResult'
      ),
  },
  {
    path: '/help/service',
    title: '帮助与客服',
    name: 'helpService',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/help/main.vue')),
        'helpService'
      ),
  },
  {
    path: '/help/list/helptype/:type',
    title: '问题列表',
    name: 'questionList',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/help/list/main.vue')),
        'questionList'
      ),
  },
  {
    path: '/user/order/self-service/type/:type',
    title: '自助服务-订单',
    name: 'selfServiceOrder',
    component: (r) =>
      require.ensure(
        [],
        () => r(require('./view/order/self_service/list.vue')),
        'selfServiceOrder'
      ),
  },
  {
    path: '/user/course',
    title: '我的课程',
    name: 'course',
    component: (r) =>
      require.ensure([], () => r(require('./view/course/list.vue')), 'course'),
  },
  {
    path: '/product/group/:groupCode',
    title: '商品模板分组详情',
    name: 'groupInfo',
    component: () => import('./view/product_template/group_info.vue'),
  },
  {
    path: '/product/scheme/:templateId',
    title: '商品模板聚合页',
    name: 'previewList',
    component: () => import('./view/product_template/group_preview/list.vue'),
  },
  {
    path: '/product/scheme/detail/:id',
    title: '商品模板商详页',
    name: 'previewDetail',
    component: () => import('./view/product_template/group_preview/detail.vue'),
  },
  {
    path: '*',
    title: '404',
    name: 'noFoundPage',
    component: (r) =>
      require.ensure([], () => r(require('./view/error/404.vue')), 'notfound'),
  },
]
// Now, because they return a promise,
// if the error is not caught, you will see a warning in the console.
// But the error was always there because trying to navigate to same location as the current one will fail
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    const keepAliveWhiteList = ['examineItem', 'itemDetail']
    if (keepAliveWhiteList.includes(to.name)) {
      from.meta.savedPosition =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
    }
    return {
      x: 0,
      y: to.meta.savedPosition || 0,
    }
  },
})

// const isKeepAlive = controlKeepAlive()

router.beforeEach((to, from, next) => {
  // 设置title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 统一处理不能正常通过 vue-router 跳转的链接
  let result
  const { name, fullPath } = to
  // 劫持 redirect 跳转
  const RE = /.*\?redirect=(.*)/
  result = fullPath.match(RE)
  if (result) {
    next(false)
    location.href = decodeURIComponent(result[1])
    return
  }

  // 劫持 alertMsg 跳转
  const AL = /.*\?alertMsg=(.*)/
  result = fullPath.match(AL)
  if (result) {
    const msg = decodeURIComponent(result[1])
    MessageBox.alert(msg)
    return
  }
  // 检测授权状 不拦截设置栏
  const redirectUrl = `${getHostName()}/v1/#${fullPath}`
  const sourceForm = getQueryUrl('from') || 'h5'
  const sourceToken = getQueryUrl('token') || ''
  if (sourceForm !== 'tmBd' && sourceToken == '') {
    if (isNeedAuthPath(name) && !isLogged()) {
      return toLogin(redirectUrl)
    }
  }

  // 企业购首页重定向
  if (
    cookie(constant.COOKIE_CO) == constant.COOKIE_CO_IS_QYG &&
    to.path == '/'
  ) {
    next(false)
    location.replace(
      `${location.origin}/v1/?co=${constant.COOKIE_CO_IS_QYG}#/global/${COMMONCONSTANT.COMMON_QYG_CATEGORY_ID}`
    )
    return
  }

  // 如果是在苏打体检小程序里面打开这些页面，根据页面title更改document.title。
  // 这个title会体现在webview的title上
  sdtj.routerBeforeEach(routes, to)

  // keep-alive
  const keepAliveWhiteList = ['examineItem', 'itemDetail']
  if (keepAliveWhiteList.includes(to.name)) {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    from.meta.scrollTop = scrollTop
  } else {
    from.meta.scrollTop = 0
  }

  // 设置需要keep-alive缓存的页面，用于后退时保持原来的浏览位置

  /* // 解决在ios微信浏览器中“复制链接“ 只能得到最开始进入的地址问题
  if (os.isIOS() && from.name  && app.isWechat() && !to.query.iwx) {
    let url = `${getHostName()}/v1/#${to.fullPath}`
    if (_.isEmpty(to.query)) {
      url = `${url}?iwx=true`
    } else {
      url = `${url}&iwx=true`
    }
    location.href = url
    return
  } */

  next()
})

export default router
